import * as React from 'react';
import UserLookup from '../../common/form-controls/UserLookup';
import FieldHandler from '../../../models/interfaces/FieldHandler';

interface ApproverInputProps extends FieldHandler<string> {
	higherApproval: boolean;
	scope?: string;
}

const ApproverInput = ( props: ApproverInputProps) => {

	return (
		<UserLookup
			label={`Approver (DOAG 8)`}
			isEmployee
			note='Select your functional management’s authority'
			{...props}
		/>
	);
}

export { ApproverInput };
